// extracted by mini-css-extract-plugin
export var background = "styles-module--background--45151";
export var banner = "styles-module--banner--19fcf";
export var content = "styles-module--content--1e400";
export var inline = "styles-module--inline--f2f17";
export var layout = "styles-module--layout--aadae";
export var secondary = "styles-module--secondary--018fb";
export var sizeCat = "styles-module--sizeCat--86289";
export var sizeDog = "styles-module--sizeDog--98d49";
export var tighten = "styles-module--tighten--1e4c3";
export var withBackground = "styles-module--withBackground--aa245";